import { Dispatch, JSX, ReactNode, SetStateAction } from "react";
import Tooltip from "./Tooltip";

function InputField<T>({
  id,
  label,
  labelTitle = "",
  type,
  placeholder,
  value,
  onChange,
  prependLabel,
  prependIcon,
  appendLabel,
  disabled,
}: {
  id?: string;
  label?: any;
  labelTitle?: string;
  type: "text" | "number" | "email" | "password" | "date";
  placeholder: string;
  value: string;
  onChange: Dispatch<SetStateAction<T>>;
  prependLabel?: string;
  prependIcon?: JSX.Element;
  appendLabel?: string;
  disabled?: boolean;
}) {
  const classNames = (...classes: string[]) => {
    return classes.filter(Boolean).join(" ");
  };

  return (
    <div>
      {label && (
        <>
          {labelTitle != "" ? (
            <>
              <Tooltip content={labelTitle} place="top-start">
                <label
                  title={labelTitle}
                  htmlFor={id}
                  className="truncate block text-sm font-medium text-gray-700"
                >
                  {label}
                </label>
              </Tooltip>
            </>
          ) : (
            <label
              htmlFor={id}
              className="truncate block text-sm font-medium text-gray-700"
            >
              {label}
            </label>
          )}
        </>
      )}
      <div className={label ? "mt-1" : ""}>
        <div className="flex border border-gray-300 rounded-md shadow-sm focus:border-orange-500 focus:ring-orange-500 sm:text-sm bg-white">
          {prependLabel && (
            <span className="inline-flex items-center pl-3 text-sm text-gray-500 border-gray-300">
              {prependLabel}
            </span>
          )}
          {prependIcon && (
            <span className="inline-flex items-center pl-3 text-sm text-gray-500 border-gray-300">
              {prependIcon}
            </span>
          )}
          <input
            type={type}
            name={id}
            id={id}
            disabled={disabled}
            className={classNames(
              "p-2 bg-transparent block border-transparent focus:border-transparent focus:ring-0 w-full border-none focus:border-none focus:ring-none sm:text-sm",
              prependLabel ? "rounded-none rounded-r-md" : "rounded-md"
            )}
            placeholder={placeholder}
            value={value}
            onChange={(e) => {
              onChange((e.target.value as unknown) as T);
            }}
          />
          {appendLabel && (
            <span className="inline-flex items-center px-3 text-sm text-gray-500 border-gray-300">
              {appendLabel}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

export default InputField;
